<template lang="html">

  <div>
    <v-card>
      <v-card-title>
        <h2>
          <v-icon>fas fa-user-circle</v-icon>
          Configuración
        </h2>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12 >
            <v-layout row wrap>
              <v-flex xs2 sm2 md2 lg2>
                <strong class="mr-1">ID</strong>
              </v-flex>
              <v-flex xs6 sm6 md6 lg6>
                <strong>{{ usuario.id}}</strong>
              </v-flex>
            </v-layout>
            <v-text-field
              label="Username"
              trim
              v-model="usuario.username"
              :counter="45"
              disabled
            ></v-text-field>
            <v-text-field
              label="E-mail"
              v-model.lazy="usuario.email"
              :rules="emailRules"
              :error-messages="emailErrors"
              required
            ></v-text-field>
          </v-flex>
          </v-layout>

          <v-layout row wrap class="mt-3">
            <v-flex xs6 sm4>
              <span class="mr-3">Fecha de Creación</span>
            </v-flex>
            <v-flex xs6 sm5>
              <span class="info--text">{{ usuario.fechaCreacion | date}}</span>
            </v-flex>
            <v-flex xs6 sm4>
              <span class="mr-3">Fecha de Actualización</span>
            </v-flex>
            <v-flex xs6 sm5>
              <span class="info--text">{{ usuario.fechaActualizacion | date}}</span>
            </v-flex>
            <v-flex xs6 sm4>
              <span class="mr-3">Usuario Creación</span>
            </v-flex>
            <v-flex xs6 sm5>
              <span v-if="usuario.usuarioCreacion" class="info--text">{{ usuario.usuarioCreacion.username}}</span>
            </v-flex>
            <v-flex xs6 sm4>
              <span class="mr-3">Grupo</span>
            </v-flex>
            <v-flex xs6 sm5>
              <span v-if="usuario.group" class="info--text">{{ usuario.group.name}}</span>
            </v-flex>
            <v-flex xs6 sm4>
              <span class="mr-3">Propietario</span>
            </v-flex>
            <v-flex xs6 sm5>
              <span v-if="usuario.propietario" class="info--text">{{ usuario.propietario.username}}</span>
            </v-flex>
          </v-layout>

        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary">
          <v-icon small left>fas fa-save</v-icon>
          Guardar
        </v-btn>
        <v-btn @click="$router.push('/')">
          <v-icon small left>fas fa-chevron-left</v-icon>
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Usuarios from '../../services/usuarios'
export default {
  name: 'PerfilComponent',
  data () {
    return {
      usuario: null,
      valid: false,
      emailRules: [
        v => !!v || 'Ingrese una dirección de email',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Ingrese una dirección email válida'
      ],
      emailErrors: []
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        Usuarios.update(this.usuario)
        .then(res => {
          this.usuario = res
          this.$emit('show-message', {msg: 'Registro Guardado', tipo: 'info'})
        })
        .catch(err => {
          this.$emit('show-message', {msg: 'Ocurrió un error, verifique la información', tipo: 'error'})
        })
      }
    }
  },
  watch: {
    'usuario.email': _.debounce(async function (newV, oldV) {
      if (!newV || !oldV) {
        this.emailErrors = []
        return
      }
      let res = await Usuarios.list({ email: newV, populate: 'group' })
      if (res.length > 0) {
        this.emailErrors = ['La dirección de email ya existe en el sistema']
      } else {
        this.emailErrors = []
      }
    },500)
  },
  beforeMount: async function(){
    this.usuario = await this.$getItem('user')
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/perfil/PerfilComponent.vue